var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header',{attrs:{"locale":_vm.appLocale,"is-order-count-supported":false,"show-login-info":true,"show-delivery-enquiry":false,"show-offers-link":false,"user-info-prop":_vm.userInfoData}})
}
var staticRenderFns = []

export { render, staticRenderFns }